export default __webpack_public_path__ + "static/media/section-image-1.c03d698a.jpg";